import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTrashAlt,
  faEdit,
  faMinusCircle,
  faQuestionCircle,
  faBars,
  faChevronUp,
  faChevronCircleUp,
  faChevronRight,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons';

import {
  loadPersonalStrategies,
  savePortfolioAsNewStrategy,
  showPersonalStrategy,
  showStrategyEditor,
  getBenchmarks,
} from '../../actions/data';

import './App.css';
import StrategyList from './StrategyList/StrategyList.js';

// Initialize Font Awesome library once
library.add(
  faTrashAlt,
  faEdit,
  faMinusCircle,
  faQuestionCircle,
  faBars,
  faChevronUp,
  faChevronCircleUp,
  faChevronRight,
  faChevronLeft
);

// Parse hashes like "#my-portfolio-hub&id=123&x=y"
function parseHash(hash) {
  const raw = (hash || '').replace(/^#/, '');
  if (!raw) return { route: '', params: new URLSearchParams() };
  const [route, ...pairs] = raw.split('&');
  const params = new URLSearchParams(pairs.join('&'));
  return { route: (route || '').trim(), params };
}

class App extends PureComponent {
  state = {
    lastProcessedHash: '',
    portfolioToSave: null,
  };

  componentDidMount() {
    const { loadPersonalStrategies, getBenchmarks } = this.props;
    loadPersonalStrategies();
    getBenchmarks();

    // Handle initial paste/open
    this.processHash(this.props.history.location.hash);

    // Handle subsequent hash changes
    this.unlisten = this.props.history.listen((location) => {
      this.processHash(location.hash);
    });
  }

  componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  }

  processHash = (hash) => {
    if (hash === this.state.lastProcessedHash) return;

    const { route, params } = parseHash(hash);

    if (!route) {
      this.setState({ lastProcessedHash: hash });
      return;
    }

    // --- Save into MyPortfolios flows ---
    if (route === 'dpd' || route === 'portfolio-analysis') {
      const toSave = params.get('saveToMyPortfolios');
      if (toSave && this.state.portfolioToSave !== toSave) {
        const rawName = params.get('portfolioName');
        const decodedName = rawName ? decodeURI(rawName) : undefined;
        this.setState({ portfolioToSave: toSave });
        this.props.savePortfolioAsNewStrategy(toSave, decodedName);
      }
      this.setState({ lastProcessedHash: hash });
      return;
    }

    // --- Deep-link: open a specific personal strategy ---
    if (route === 'myportfolios' || route === 'my-portfolio-hub') {
      const id = params.get('id') || params.get('myportfolioid');
      if (id) {
        const currentOpen = this.props.data?.strategyIdToShow;
        if (currentOpen !== id) {
          this.props.showPersonalStrategy(id);
        }
      } else if (params.get('newstrategy')) {
        this.props.showStrategyEditor(null);
      }
      this.setState({ lastProcessedHash: hash });
      return;
    }

    // Default: nothing to do
    this.setState({ lastProcessedHash: hash });
  };

  render() {
    const { params } = this.props;
    return (
      <div className="app">
        <div>
          <div className="top-of-app" id="personal-strategy-top-of-app">
            <div className="version">{'V' + params.version}</div>
          </div>
          <StrategyList />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    params: state.params,
    data: state.data,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    loadPersonalStrategies,
    savePortfolioAsNewStrategy,
    showPersonalStrategy,
    showStrategyEditor,
    getBenchmarks,
  })(App)
);
